module.exports = __webpack_public_path__ + "img/029-potion.562d734b.png";